<script setup>
/**
 * FormControlTemplatesTemplatesCssGroupName
 * A dropdown select for choosing a CSS group name.
 * It fetches available CSS group names from the themes_css component API endpoint
 * and populates the dropdown with unique, sorted group names.
 */
import {ref, computed, onMounted} from 'vue'
import formValidation from '@/vue/directives/formValidation'
import api from '@/services/api'

// Register the local directive for use in the template
const vFormValidation = formValidation

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
})

const components = ref([])

const options = computed(() => {
    if (components.value) {
        const groups = new Set()
        components.value.forEach((component) => {
            if (component.groups) {
                component.groups.forEach((group) => {
                    groups.add(group)
                })
            }
        })

        const sortedGroups = Array.from(groups).sort()

        return sortedGroups.map((group) => ({
            value: group,
            text: group,
        }))
    }
    return []
})

const fetchComponents = async () => {
    try {
        const obj = await api.get('api/component/themes_css')
        components.value = obj.data.items
    } catch (error) {
        console.error('Failed to fetch CSS components:', error)
    }
}

onMounted(() => {
    fetchComponents()
})
</script>

<template>
    <select
        :id="field.id"
        v-model="currentData[field.name]"
        v-form-validation
        :name="field.name"
        :required="field.required"
        class="form-select"
    >
        <option :value="''">- none -</option>
        <option
            v-for="option in options"
            :key="option.value"
            :value="option.value"
        >
            {{ option.text }}
        </option>
    </select>
</template>